import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import {
  AuthRoles,
  MeteringPointCalculationParameterDto,
  MeteringPointCalculationStructureDto,
  MeteringPointCalculationStructureService
} from '@app/api/dmc';
import { HeaderService } from '@app/core/services/header.service';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { TableComponent } from '@shared/components/table/table.component';
import {
  meteringpointCalculationStructureTable
} from '@shared/table-configs/meteringpoint/meteringpoint-calculation-structure.table';
import {
  meteringPointCalculationMenuAction
} from '@views/meteringpoint/meteringpoint-calculation/meteringpoint-calculation.action-menu';
import { ModalService } from '@app/core/services/modal.service';
import {
  CreateCalculationModalComponent
} from '@shared/modals/meteringpoint/calculation/create-calculation-modal/create-calculation-modal.component';
import {
  meteringPointIdentificationPartial,
  meterNumberPartial,
  meterReadingOccurrencePartial
} from '@shared/columns/meteringpoint.columns';
import { meteringPointSubtypePartial } from '@shared/partials/meteringpointsubtype.partial';
import { MenuAction } from '@shared/interfaces/header/menu-action';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { hasRole } from '@app/core/guards/has-role.guard';


@Component({
  selector: 'app-meteringpoint-calculation',
  imports: [
    TableComponent
  ],
  templateUrl: './meteringpoint-calculation.component.html',
  styleUrl: './meteringpoint-calculation.component.css'
})
export class MeteringpointCalculationComponent implements OnInit {
  /** ID **/
  public id?: string;

  public mpWriter = hasRole([AuthRoles.MeteringPointWriter]);
  public actions: MenuAction[] = [
    {
      ...meteringPointCalculationMenuAction[0],
      callback: () => this.openChangeModal(),
      disabled: () => !this.mpWriter
    },
  ]

  /** Table **/
  public calculationQueryResultTable: TableConfig<MeteringPointCalculationStructureDto> = {
    ...meteringpointCalculationStructureTable,
    contextActions: [
      this.actions[1],
    ],
    refreshable: true,
    refresh: () => this.fetchData(),
  };

  /** Table Data **/
  public calculationQueryResultData: MeteringPointCalculationStructureDto[] = [];

  /** Selection **/
  public selectedElements: MeteringPointCalculationStructureDto[] = [];

  /** Detail Table **/
  public detailTable: TableConfig<any> = {
    id: 'meteringPoint-calculation-detail',
    columns: [
      {
        title: 'meteringPoint.calculation.parameter.name',
        key: 'internalName'
      },
      {
        ...meteringPointIdentificationPartial,
        key: 'meteringPointIdentification',
        cellRendererParams: {
          url: '/meteringpoint',
          urlReference: 'meteringPointIdentification',
        }
      },
      {
        ...meteringPointSubtypePartial,
        key: 'meterPointSubType',
      },
      {
        ...meteringPointTypePartial,
      },
      meterReadingOccurrencePartial,
      {
        ...meterNumberPartial,
        key: 'meterIdentification',
      },
    ]
  }

  public detailTableData: MeteringPointCalculationParameterDto[] = [];


  constructor(
    private readonly route: ActivatedRoute,
    private readonly headerMenuService: HeaderService,
    private readonly queryService: MeteringPointCalculationStructureService,
    private readonly modalService: ModalService,
  ) {
    this.headerMenuService.setActions(this.actions);
  }

  public ngOnInit(): void {
    this.route.parent?.paramMap.subscribe((q: ParamMap) => {
      this.id = q.get('id')!;

      this.fetchData();
    });
  }

  public fetchData(): void {
    this.queryService.meteringPointCalculationStructureQueryPost({
      meteringPointIdentification: this.id
    }).subscribe((data: MeteringPointCalculationStructureDto[]) => {
      this.calculationQueryResultData = data;
    })
  }

  public elementSelected(event: MeteringPointCalculationStructureDto[]): void {
    this.detailTableData = event[0]?.parameters ?? [];
  }

  public openChangeModal(): void {
    this.modalService.show({
      component: CreateCalculationModalComponent,
      title: 'meteringPoint.calculation.create.title',
      actions: [
        { type: 'primary', label: 'system.button.create', method: 'submit' },
        { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
      ],
      params: {
        id: this.id,
      }
    }).subscribe(() => {
      this.fetchData();
    })
  }
}
